import { Component, OnInit, ViewChild } from '@angular/core';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { ConfirmationService, MessageService } from 'primeng/api';
import { firstValueFrom, forkJoin } from 'rxjs';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AccessRole, ButtonColumnType, CustomTableComponent, CustomTitle, DataColumnType, FormGroupErrorMessageComponent, ICustomTable, LoadingPanelService, LocalService, noWhitespaceValidator, Utils } from 'lib-base';
import { ActividadesService } from '../../../../services/database/pqrsd/actividades.service';
import { IGetActividades } from '../../../../shared/interfaces/database/pqrsd';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { CommonModule } from '@angular/common';
import { ISecPermiso } from '../../../../shared/interfaces/database/seguridad';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { SecPermisoService } from '../../../../services/database/secPermiso.service';
import { PqrsdActividadesHistoricoComponent } from './pqrsd-actividades-historico/pqrsd-actividades-historico.component';

@Component({
  selector: 'app-pqrsd-actividades',
  standalone: true,
  imports: [CustomTableComponent, ConfirmPopupModule, DialogModule, CustomTitle, ReactiveFormsModule, ButtonModule, TranslateModule,
    FormGroupErrorMessageComponent, CommonModule, DropdownModule, InputTextModule, PqrsdActividadesHistoricoComponent
  ],
  providers: [ConfirmationService],
  templateUrl: './pqrsd-actividades.component.html',
  styleUrl: './pqrsd-actividades.component.scss'
})
export class PqrsdActividadesComponent implements OnInit {
  role = AccessRole;
  trans: any = {};
  customTable !: ICustomTable;
  @ViewChild(CustomTableComponent) customTableComponent !: CustomTableComponent;
  @ViewChild(PqrsdActividadesHistoricoComponent) historico !: PqrsdActividadesHistoricoComponent;
  

  //Form Modal
  formTitle = '';
  displayModal = false;
  form !: FormGroup;
  private _editValue !: IGetActividades | undefined;
  private _originalValues: any;
  permisos !: ISecPermiso[];

  

  constructor(private readonly _t: TranslateService, private readonly _as: ActividadesService, private readonly _lps: LoadingPanelService,
    public ls: LocalService, private readonly _fb: FormBuilder, private readonly _cs: ConfirmationService, private readonly _ms: MessageService,
    private readonly _sp: SecPermisoService
  ) {
    this.configureForm();
  }

  ngOnInit(): void {
    this.translate().then(() => this.configurarTabla());
    this.getPermisos();
  }

  get isNewForm(): boolean {
    return this._editValue === undefined;
  }

  private async translate(): Promise<void> {
    this.trans = await firstValueFrom(forkJoin({
      codificacion: this._t.get('common.codificacion'),
      descripcion: this._t.get('common.descripcion'),
      permiso: this._t.get('common.permiso'),
      requiereRolSeguridad: this._t.get('msg.requiere-rol-seguridad'),
      nuevaActividad: this._t.get('msg.nuevaActividad'),
      editarActividad: this._t.get('msg.editarActividad'),
      noCambiosFormulario: this._t.get('msg.noCambiosFormulario'),
      completeCamposRequeridos: this._t.get('msg.completeCamposRequeridos'),
      actividadActualizada: this._t.get('msg.actividadActualizada'),
      actividadCreada: this._t.get('msg.actividadCreada'),
      actividadEliminada: this._t.get('msg.actividadEliminada'),
      advertenciaCompletarCampos: this._t.get('msg.advertenciaCompletarCampos'),
      estasSeguroEliminarActividad: this._t.get('msg.estasSeguroEliminarActividad'),
      advertencia: this._t.get('common.advertencia'),
    }));
  }

  private configurarTabla() {
    this.customTable = {
      columns: [
        {
          field: 'codificacion',
          header: this.trans.codificacion,
          sort: true,
          class:'font-13',
          columnmHeader: {
            class:'text-left color-blue-2 font-13 font-bold',
            style:''
          },
          columnFilter: true,
          dataType: DataColumnType.TEXT
        },
        {
          field: 'descripcion',
          header: this.trans.descripcion,
          class:'font-13',
          columnmHeader: {
            class:'text-left color-blue-2 font-13 font-bold',
            style:''
          },
          dataType: DataColumnType.TEXT
        },
        {
          field: 'permiso',
          header: this.trans.permiso,
          dataType: DataColumnType.TEXT,
          class:'font-13',
          columnmHeader: {
            class:'text-left color-blue-2 font-13 font-bold',
            style:''
          },
        },
        {
          field: 'abrir',
          header: '',
          icon: 'pi pi-history',
          class: 'button-edit p-button-outlined pt-2 pb-2 pr-0',
          width: '0rem',
          severity: 'info',
          buttonType: ButtonColumnType.CUSTOM,
          onClick: (event: Event, data: IGetActividades) => this.abrirHistorial(data),
        },
        {
          field: 'edit',
          header: '',
          width: '0rem',
          class: 'pt-2 pb-2 pl-1 pr-1',
          buttonType: ButtonColumnType.EDIT,
          disabled: !this.ls.hasRole(this.role.ADMIN_PQRSD),
          tooltip: {
            message: this.trans.requiereRolSeguridad
          },
          onClick: (event: Event, data: IGetActividades) => this.openEditModal(data),
          headerBtn: {
            icon: 'pi pi-history',
            class: 'pt-2 pb-2 pl-0 pr-0',
            severity: 'info',
            onClick: (event: Event) => this.abrirHistorialEliminado(),                  
          }
        },
        {
          field: 'delete',
          header: '',
          width: '0rem',
          class: 'pt-2 pb-2 pl-0',
          buttonType: ButtonColumnType.DELETE,
          disabled: !this.ls.hasRole(this.role.ADMIN_PQRSD),
          tooltip: {
            message: this.trans.requiereRolSeguridad
          },
          onClick: (event: Event, data: IGetActividades) => this.deleteConfirmation(event, data),
          headerBtn: {
            icon: 'pi pi-plus',
            class: 'pt-2 pb-2 pl-0 pr-0',
            onClick: (event: Event) => this.openNewModal(),
            disabled: !this.ls.hasRole(this.role.ADMIN_PQRSD),
          },
          headerTooltip: {
            message: this.trans.requiereRolSeguridad,
            disabled: this.ls.hasRole(this.role.ADMIN_PQRSD)
          }
        }
      ],
    } as ICustomTable;
  }

  resetForm() {
    this.form.reset();
  }

  configureForm() {
    this.form = this._fb.group({
      codificacion: [null, [Validators.required, noWhitespaceValidator, Validators.maxLength(20)]],
      descripcion: [null, [Validators.required, noWhitespaceValidator, Validators.maxLength(100)]],
      permiso: [null, [Validators.required]],
    });
  }

  openNewModal() {
    this.resetForm();
    this.formTitle = this.trans.nuevaActividad;
    this._editValue = undefined;
    this.displayModal = true;
  }

  openEditModal(data: IGetActividades) {
    this.resetForm();
    this.formTitle = this.trans.editarActividad;
    this._editValue = data;
    this.form.get('codificacion')?.setValue(data.codificacion);
    this.form.get('descripcion')?.setValue(data.descripcion);
    this.form.get('permiso')?.setValue(data.permisoId);
    this.displayModal = true;
    this._originalValues = { ...this.form.value };
  }

  deleteConfirmation(event: Event, data: IGetActividades) {
    this._cs.confirm({
      target: event.target as EventTarget,
      message: this.trans.estasSeguroEliminarActividad,
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.deleteActividad(data.id);
      },
      reject: () => {

      }
    });
  }

  onSubmit() {
    if (this.form.pristine) {
      this._ms.add({ severity: 'warn', summary: this.trans.advertencia, detail: this.trans.noCambiosFormulario });
      return;
    }

    if (this.form.invalid) {
      Utils.markAllFormControlsAsTouched(this.form);
      this._ms.add({ severity: 'warn', summary: this.trans.advertencia, detail: this.trans.noCambiosFormulario });
      return;
    }

    const newValues = {
      permisoId: this.form.get('permiso')?.value,
      codificacion: this.form.get('codificacion')?.value,
      descripcion: this.form.get('descripcion')?.value
    } as IGetActividades;

    if (this.isNewForm) {
      this.createActividad(newValues);
    } else if (!Utils.isDeepEqual(this._originalValues, newValues)) {
      this.updateActividad(newValues);
    } else {
      this._ms.add({ severity: 'warn', summary: this.trans.advertencia, detail: this.trans.noCambiosFormulario });
    }
  }

    abrirHistorial(data: IGetActividades): void {
      this.historico.show(data.id);
    }
  
    abrirHistorialEliminado(): void {
      this.historico.showEliminado();
    }

  //#region API Calls
  getActividades(): void {
    this._as.getActividades().subscribe({
      next: (data: IGetActividades[]) => {
        this.customTableComponent.data = data;
      },
    });
  }

  updateActividad(actividad: IGetActividades) {
    if (!this._editValue) return;
    this._lps.show(true);
    this._as.updateActividad(this._editValue.id, actividad).subscribe({
      next: (response: boolean) => {
        this._lps.hide();
        this._ms.add({ severity: 'success', summary: 'Éxito', detail: this.trans.actividadActualizada });
        this.getActividades();
        this.displayModal = false;
      }
    });
  }

  createActividad(actividad: IGetActividades) {
    this._lps.show(true);
    this._as.createActividad(actividad).subscribe({
      next: (response: boolean) => {
        this._lps.hide();
        this._ms.add({ severity: 'success', summary: 'Éxito', detail: this.trans.actividadCreada });
        this.getActividades();
        this.displayModal = false;
      },
    });
  }

  deleteActividad(actividadId: number) {
    this._lps.show(true);
    this._as.deleteActividad(actividadId).subscribe({
      next: (response: boolean) => {
        this._lps.hide();
        this._ms.add({ severity: 'success', summary: 'Éxito', detail: this.trans.actividadEliminada });
        this.getActividades();
      }
    });
  }

  getPermisos() {
    this._sp.getSecPermisosByTipo('TRAMITE').subscribe({
      next: (response: ISecPermiso[]) => {
        this.permisos = response;
      }
    });
  }
  //#endregion API Calls
}
